import { useModal } from 'components/Modal';
import NameForm from 'presets/NameForm';
import { create } from 'presets/data/queryKeyFactory';
import { createPreset } from 'presets/sources/createPreset';
import { useMutation } from 'query';

export const useCreatePreset = (screenKey: string) => {
  const [openNameForm] = useModal(NameForm);
  const createMutation = useMutation(create(), createPreset, {
    successMessage: () => `Preset created`,
    refresh: true,
  });

  const handleAction = async (state: any) => {
    const title = await openNameForm({
      title: 'Add Preset',
      data: [],
      screenKey,
    });

    return await createMutation.mutateAsync({
      data: state,
      title,
      screen: screenKey,
    } as any);
  };

  return [handleAction, createMutation];
};
